import { useEffect, useState } from 'react';
import { i18n as Ii18n } from 'i18next';
import { Language } from '@data/utils/enums';
import { setLanguageParam } from '../helpers';

export const useDetectLanguage = (i18next: Ii18n) => {
  const searchParams = new URLSearchParams(window.location.search);
  const [lang, setLang] = useState<Language | undefined>(searchParams.get('lang') as Language);
  const locales = Object.values(Language);

  useEffect(() => {
    if (lang) {
      const language = locales.includes(lang) ? lang : locales[0];
      if (language !== i18next.language) {
        i18next.changeLanguage(language);
      }
    }
  }, [lang]);

  const changeQueryLanguage = (newLang: Language) => {
    if (!locales.includes(newLang)) return;

    window.history.replaceState(null, '', setLanguageParam(window.location.href, newLang));
    setLang(newLang);
  };

  return { lang, changeQueryLanguage };
};
